<template>
  <div class="container">
    <div class="main" v-loading="loading">
      <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{ id ? $t('editChild.edit') : $t('faultEdit.add') }}</span>
        </div>
        <div class="right">
          <el-button class="submit-btn" icon="el-icon-plus" @click="submitForm('ruleForm')">{{$t('login.submit')}}</el-button>
          <el-button class="back-btn" icon="el-icon-back" @click="returnBack">{{$t('applyChildDetail.return')}}</el-button>
        </div>
      </div>
      <div class="edit-box">
        <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('applyChild.code')" prop="code">
            <el-input v-model="ruleForm.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('warehouseDetail.name')" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyChild.size')" prop="specification">
            <el-input v-model="ruleForm.specification"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyChild.model')" prop="model">
            <el-input v-model="ruleForm.model"></el-input>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.price')" prop="price">
            <el-input v-model.number="ruleForm.price"></el-input>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.priceUnit')" prop="priceUnit">
            <el-select v-model="ruleForm.priceUnit" :placeholder="$t('goodsManIndex.choPriceInit')">
              <el-option
              v-for="(item, index) in priceUnitList"
              :key="index"
              :label="item.unit"
              :value="item.unit">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.countryLanguage')" prop="language">
            <el-select v-model="ruleForm.language" :placeholder="$t('goodsEdit.choCountryLanguage')">
              <el-option
              v-for="(item, index) in languageList"
              :key="index"
              :label="item.tenantName"
              :value="item.tenantId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.carouselChart')" prop="carousel">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'carousel') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'carousel') }"
              :file-list="ruleForm.carousel"
              :limit="4"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('goodsEdit.onlyPng')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.videoUpload')" prop="video">
            <VideoUpload :fileList="ruleForm.videoList" @uploadVideos="uploadVideos" :limit="1" />
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.coverImage')" prop="coverImg">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'coverImg') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'coverImg') }"
              :file-list="ruleForm.coverImg"
              :limit="1"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('goodsEdit.onlyPng')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('goodsDetail.introduce')" prop="brief">
            <el-input
              type="textarea"
              :placeholder="$t('goodsEdit.inputIntro')"
              v-model="ruleForm.brief"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('goodsDetail.instruction')" prop="instructions">
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              action=""
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'instructions') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'instructions') }"
              :before-remove="beforeRemove"
              multiple
              :limit="5"
              :on-exceed="handleExceed"
              :file-list="ruleForm.instructions">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('goodsEdit.imageWordIntro')" prop="graphicDescription">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'graphicDescription') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'graphicDescription') }"
              :file-list="ruleForm.graphicDescription"
              :limit="5"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('goodsEdit.imageOrderUpload')}}</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { rules } from "./config/index"
import {
  uploadFile,
  getLanguageList,
  getPriceUnitList,
  addProduct,
  addParts,
  addMaterial,
  getProductDetail,
  getPartDetail,
  getMaterialDetail,
  editProduct,
  editParts,
  editMaterial
  } from "../../api/goods/index"
import VideoUpload from "../../components/upload/video-upload"
  export default {
    props: {},
    components: {
      VideoUpload
    },
    data() {
      return {
        ruleForm: {
          code: '',
          name: '',
          specification: '',
          model: '',
          price: '',
          priceUnit: '',
          language: '',
          carousel: [],
          videoList: [],
          coverImg: [],
          brief: '',
          instructions: [],
          graphicDescription: []
        },
        dataSource: [],
        formRules: rules,
        languageList: [],
        priceUnitList: [],
        postParams: {},
        submitApi: null,
        editApi: null,
        detailApi: null,
        loading: false
      }
    },
    created(){
      
    },
    computed: {
      id() {
        if(this.$route.query && this.$route.query.id) {
          return this.$route.query.id
        }
      },
      type() {
        if(this.$route.query && this.$route.query.type) {
          return this.$route.query.type;
        }
      },
			// 产品参数
			productParams() {
				const _return = {
				   id: this.id,
           name: this.ruleForm.name,
				   model: this.ruleForm.model,
				   code: this.ruleForm.code,
				   specification: this.ruleForm.specification,
				   price: this.ruleForm.price,
				   unit: this.ruleForm.priceUnit,
				   photo: this.ruleForm.coverImg.length ? this.ruleForm.coverImg.map(x => x.url).join(",") : '',
				   productDescribe: this.ruleForm.brief,
				   detail: this.ruleForm.graphicDescription.length ? this.ruleForm.graphicDescription.map(x => x.url).join(",") : '',
				   slidePhoto: this.ruleForm.carousel.length ?
           this.ruleForm.carousel.map(x => x.url).concat(this.ruleForm.videoList.map(v => v.url)).join(",") : '',
				   productExplain: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.url).join(",") : '',
           productExplainSize: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.size).join(",") : '',
				   productExplainName: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.name).join(",") : '',
				   tenantId: this.ruleForm.language
				};
				return _return;
			},
      // 配件参数
			partsParams() {
				const _return = {
				   id: this.id,
           name: this.ruleForm.name,
				   model: this.ruleForm.model,
				   code: this.ruleForm.code,
				   specification: this.ruleForm.specification,
				   price: this.ruleForm.price,
				   unit: this.ruleForm.priceUnit,
				   photo: this.ruleForm.coverImg.length ? this.ruleForm.coverImg.map(x => x.url).join(",") : '',
				   partDescribe: this.ruleForm.brief,
				   detail: this.ruleForm.graphicDescription.length ? this.ruleForm.graphicDescription.map(x => x.url).join(",") : '',
				   slidePhoto: this.ruleForm.carousel.length ?
           this.ruleForm.carousel.map(x => x.url).concat(this.ruleForm.videoList.map(v => v.url)).join(",") : '',
				   partExplain: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.url).join(",") : '',
           partExplainSize: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.size).join(",") : '',
				   partExplainName: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.name).join(",") : '',
				   tenantId: this.ruleForm.language
				};
				return _return;
			},
			// 辅料参数
			materialParams() {
				const _return = {
				   id: this.id,
           name: this.ruleForm.name,
				   model: this.ruleForm.model,
				   code: this.ruleForm.code,
				   specification: this.ruleForm.specification,
				   price: this.ruleForm.price,
				   unit: this.ruleForm.priceUnit,
				   photo: this.ruleForm.coverImg.length ? this.ruleForm.coverImg.map(x => x.url).join(",") : '',
				   materialDescribe: this.ruleForm.brief,
				   detail: this.ruleForm.graphicDescription.length ? this.ruleForm.graphicDescription.map(x => x.url).join(",") : '',
				   slidePhoto: this.ruleForm.carousel.length ?
           this.ruleForm.carousel.map(x => x.url).concat(this.ruleForm.videoList.map(v => v.url)).join(",") : '',
				   materialExplain: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.url).join(",") : '',
				   materialExplainName: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.name).join(",") : '',
           materialExplainSize: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.size).join(",") : '',
				   tenantId: this.ruleForm.language
				};
				return _return;
			}
    },
    created() {
      this.getLanguageList();
      this.getPriceUnitList();
      if(this.id) {
        this.getDetail()
      }
    },
    methods: {
      // 参数转换
			handParamsChange(e) {
				switch(e) {
					case 'product':
						this.postParams = this.productParams;
						break;
					case 'part':
						this.postParams = this.partsParams;
						break;
					case 'material':
						this.postParams = this.materialParams;
						break;
				}
			},
      handleSubmitApiChange(e) {
         switch(e) {
            case 'product':
                return addProduct;
            case 'part':
                return addParts;
            case 'material':
                return addMaterial;
         }
      },
      handleDetailApiChange(e) {
          switch(e) {
              case 'product':
                  return getProductDetail;
              case 'part':
                  return getPartDetail;
              case 'material':
                  return getMaterialDetail;
          }
      },
      hadleEditApiChange(e) {
          switch(e) {
              case 'product':
                  return editProduct;
              case 'part':
                  return editParts;
              case 'material':
                  return editMaterial;
          }
      },
      handleRemove(file, fileList, target) {
        let currentIndex;
        this.ruleForm[target].map((x,idx) => {
          if(file.uid === x.uid) {
            currentIndex = idx;
          }
        })
        this.ruleForm[target].splice(currentIndex, 1);
        console.log(this.ruleForm[target], target);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(this.$t('componentsReply.momentLimitThree')+ `${files.length}` +this.$t('componentsReply.aTotalOf') +`${files.length + fileList.length}`+ this.$t('componentsReply.individualFile'));
      },
      beforeRemove(file, fileList) {
        return this.$confirm(this.$t('componentsReply.sureRemove') +`${ file.name }？`);
      },
      async uploadFile(file, fileList, target) {
        console.log('file', file);
        console.log('target', target)
        let fileList1 = [];
        let FormDatas = new FormData()
        FormDatas.append('file',file.raw);
        let { data } = await uploadFile(FormDatas);
        console.log('data', data)
        if(data && data.code === 200) {
          this.$message.success(this.$t('AAAA.uploadSuccess'))
          let obj = {
            domain: data.data.domain,
            status: "success",
            name: data.data.originalName,
            size: file.size,
            url: data.data.link,
          }
          this.ruleForm[target].push(obj)
        } else {
          for(var i = 0; i < fileList1.length; i++){
            if(i + 1 == fileList1.length){
              fileList1.splice(i,1)
            }
          }
          this.$message.error(data.msg)
          return
        }
      },
      // 接收视频
      uploadVideos(videoList) {
        console.log(videoList, 'uploadVideos')
        this.ruleForm.videoList = videoList;
      },
      returnBack() {
         this.$EvenBus.$emit('menuTag', this.$route.fullPath, 'remove');
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.id) {
              this.editItem();
            }else {
              this.addItem();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 新增
      async addItem() {
        this.loading = true;
        this.submitApi = this.handleSubmitApiChange(this.$route.meta.type);
        this.handParamsChange(this.$route.meta.type)
        const res = await this.submitApi({...this.postParams, type: this.type});
        if(res.data && res.data.code === 200) {
          this.$message.success(this.$t('componentsReply.addSuccess'));
          setTimeout(() => {
             this.returnBack();
          },1000)
        }
        this.loading = false
      },
      // 编辑
      async editItem() {
        this.loading = true;
        this.handParamsChange(this.$route.meta.type)
        this.editApi = this.hadleEditApiChange(this.$route.meta.type);
        const res = await this.editApi({...this.postParams, type: this.type});
        if(res.data && res.data.code === 200) {
          this.$message.success(this.$t('faultEdit.editSuccess'));
          setTimeout(() => {
             this.returnBack();
          },1000)
        }
        this.loading = false;
      },
      // 获取语言列表
      async getLanguageList() {
        const res = await getLanguageList();
        console.log('res =>', res);
        if(res && res.data.code === 200) {
          this.languageList = res.data.data;
        }
      },
      // 获取价格单位
      async getPriceUnitList() {
        const res = await getPriceUnitList();
        console.log('res =>', res);
        if(res.data && res.data.code === 200) {
          this.priceUnitList = res.data.data;
        }
      },
      // 说明书附件格式转换
      explainFormatter(arr, arr1, arr2) {
          let newArr = []
          let nameList = arr && arr.split(",");
          let urlList = arr1 && arr1.split(",");
          let sizeList = arr2 && arr2.split(",");
          if(nameList.length && urlList.length && sizeList.length) {
              urlList.map((x, idx) => {
                  newArr.push({
                      name: nameList[idx],
                      url: x,
                      size: sizeList[idx]
                  })
              })
          }
          console.log('newArr', newArr);
          return newArr;
      },
      // 获取详情
      async getDetail() {
        this.loading = true;
        this.detailApi = this.handleDetailApiChange(this.$route.meta.type);
        const res = await this.detailApi(this.id);
        console.log('res =>', res.data);
        if(res.data && res.data.code === 200) {
            this.ruleForm.name = res.data.data.name;
            this.ruleForm.code = res.data.data.code;
            this.ruleForm.specification = res.data.data.specification;
            this.ruleForm.model = res.data.data.model;
            this.ruleForm.price = Number(res.data.data.price);
            this.ruleForm.priceUnit = res.data.data.unit;
            this.ruleForm.language = res.data.data.tenantId;
            this.ruleForm.brief = res.data.data.productDescribe
            ? res.data.data.productDescribe : res.data.data.partDescribe
            ? res.data.data.partDescribe : res.data.data.materialDescribe
            ? res.data.data.materialDescribe : ''
            this.ruleForm.carousel = res.data.data.slidePhotoList ? res.data.data.slidePhotoList.filter((x => x.type !== 'video')) :[];

            this.ruleForm.videoList = res.data.data.slidePhotoList ? res.data.data.slidePhotoList.filter((v => v.type === 'video')):[];
            res.data.data.photo && res.data.data.photo.split(",").map(x => {
              this.ruleForm.coverImg.push({
                url: x
              })
            })
            this.ruleForm.instructions = this.explainFormatter(res.data.data.productExplainName
            ? res.data.data.productExplainName : res.data.data.partExplainName
            ? res.data.data.partExplainName : res.data.data.materialExplainName
            ? res.data.data.materialExplainName : '',
            res.data.data.productExplain
            ? res.data.data.productExplain : res.data.data.partExplain
            ? res.data.data.partExplain : res.data.data.materialExplain
            ? res.data.data.materialExplain : '',
            res.data.data.productExplainSize
            ? res.data.data.productExplainSize : res.data.data.partExplainSize
            ? res.data.data.partExplainSize : res.data.data.materialExplainSize
            ? res.data.data.materialExplainSize : '');
            res.data.data.detail && res.data.data.detail.split(",").map(v => {
              this.ruleForm.graphicDescription.push({
                url: v
              })
            })
        }
        this.loading = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}
.main {
  background-color: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    .left {
      display: flex;
      align-items: center;
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01AAA7;
        border-radius: 2px;
      }
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01AAA7;
        border-radius: 1px;
      }
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      .submit-btn {
        background-color: #01AAA7;
        color: #fff;
      }
      .back-btn {
        color: #01AAA7;
        border-color: #01AAA7;
      }
    }
  }
  .edit-box {
    width: 600px;
    padding: 23px 0;
    margin: 0 auto;
  }
}

/deep/ .upload-demo .el-button {
    background-color: #01AAA7;
    color: #fff;
    border-color: #01AAA7;
}
</style>
